import { Component, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  CheckboxToggleDef,
  ControlType,
} from '@domgen/dgx-fe-dynamic-form-builder';
import { Observable } from 'rxjs';
import { distinctUntilChanged, pluck } from 'rxjs/operators';
@Component({
  selector: 'sky-lost-theft-form',
  templateUrl: './lost-theft-form.component.html',
  styleUrls: ['./lost-theft-form.component.scss'],
})
export class LostTheftFormComponent implements OnInit {
  isExpanded = false;
  public formGroup = new UntypedFormGroup({
    addProtection: new UntypedFormControl(''),
  });
  field: CheckboxToggleDef = {
    controlType: ControlType.CHECKBOX,
    controlName: 'addProtection',
    initialValue: false,
    validators: [],
    label: {
      text: 'Add protection against loss and theft',
    },
  };

  @Input() amount: number | undefined;
  @Input() initialValue: boolean | undefined = false;
  @Output() formChanges: Observable<boolean> = this.formGroup.valueChanges.pipe(
    pluck('addProtection'),
    distinctUntilChanged()
  );

  ngOnInit() {
    this.formGroup.patchValue({
      addProtection: this.initialValue,
    });
  }
}
